// Mint-Mov-Phone3 khung 2 "Xe của tôi": dữ liệu mẫu + logic thuần (giữ trong bộ nhớ, không ghi DB).
export const VEHICLE = {
  plate: '50E13970', model: 'Chenglong H7 420Hp', own: 'xe nhà',
  rows: [
    { k: 'Mooc 50RM07187', v: 'Mooc lạnh 40′ · đăng kiểm 22/08/2027' },
    { k: 'Đăng kiểm đầu kéo', v: '26/04/2027', tone: 'ok' as const },
    { k: 'Bảo hiểm', v: 'TNDS · còn hạn', tone: 'ok' as const },
  ],
  odo0: '186.420',
} as const;

export const REPORT_ITEMS = ['Đầu xe', 'Lốp trước', 'Lốp sau', 'Đèn', 'Phanh', 'Máy lạnh mooc', 'Cabin', 'Giấy tờ'] as const;
export type ReportItem = (typeof REPORT_ITEMS)[number];
export const REPORT0: Readonly<Record<ReportItem, boolean>> = {
  'Đầu xe': true, 'Lốp trước': true, 'Lốp sau': true, 'Đèn': true, 'Phanh': false, 'Máy lạnh mooc': true, 'Cabin': false, 'Giấy tờ': true,
};

export const MAINT = [
  { k: 'BD1 dự kiến 02/11/2026', v: 'ODO 190.000 km · còn khoảng 3.580 km', tone: 'warn' as const },
  { k: 'BD2 · 14/06/2026', v: 'Garage Chenglong Bình Chánh · đã làm', tone: 'ok' as const },
  { k: 'Lốp sau trái mòn 70%', v: 'Ask HANA phát hiện từ ảnh tháng 9 · đã báo Vận tải', tone: 'warn' as const },
];

export type Range = '7 ngày' | '30 ngày';
export const INDEX: Record<Range, readonly (readonly [string, string])[]> = {
  '7 ngày': [['Chuyến', '9'], ['Km', '1.108 km'], ['Nhiên liệu', '33,6 lít/100 km'], ['Đúng giờ', '8/9 chuyến']],
  '30 ngày': [['Chuyến', '27'], ['Km', '3.410 km'], ['Nhiên liệu', '34,1 lít/100 km'], ['Đúng giờ', '24/27 chuyến']],
};

export const FUEL_BRANDS = ['Petrolimex', 'PVOil', 'Thẻ dầu công ty'] as const;
export const FUEL_PRICE = 19850;

export const reportCount = (r: Readonly<Record<string, boolean>>) => Object.values(r).filter(Boolean).length;
export const reportBtn = (n: number) => (n === REPORT_ITEMS.length ? 'Gửi báo cáo xe' : `Còn ${REPORT_ITEMS.length - n} hạng mục chưa chụp`);
export const parseLit = (s: string) => { const n = Number(s.replace(',', '.')); return Number.isFinite(n) && n > 0 ? n : 0; };
export const fuelCost = (lit: number) => Math.round(lit * FUEL_PRICE);
export const fmtVnd = (n: number) => n.toLocaleString('de-DE');
export const odoOk = (odo: string, photo: boolean) => odo.trim() !== '' && photo;
